export default __webpack_public_path__ + "static/media/meta-partners-logo.74662fcf.svg";